import React from 'react'
import joystickLogo from "../../assets/images/joystick-logo.jpg"

import "./Loading.scss"

function Loading() {
  return (
    <div>
      <img
        className="joystick-logo"
        width={100}
        src={joystickLogo}
        alt="Joystick logo"
      />
    </div>
  )
}

export default Loading
